import SkeletonCard from './SkeletonCard';

interface SkeletonGridProps {
  count?: number;
  className?: string;
}

const SkeletonGrid = ({ count = 8, className = '' }: SkeletonGridProps) => {
  return (
    <div className={`grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 ${className}`}>
      {Array.from({ length: count }, (_, index) => (
        <SkeletonCard key={index} />
      ))}
    </div>
  );
};

export default SkeletonGrid;